import { Button } from "@studyplus/boron-ui";
import * as React from "react";
import { Modal } from "../../../../components/atoms/Modal";
import { Schedule } from "../../../../domains/Schedule";
import {
  MutateScheduleProps,
  useMutateSchedule,
  useRollback,
} from "../useScheduleApi";
import styles from "./styles.scss";

export type Props = {
  onClose: () => void;
  schedule: Schedule;
  onMutateSuccess: (message: string) => void;
  onMutateError: (message: string) => void;
} & MutateScheduleProps;

export const ConfirmFromDragAndDropSingleEdit = (props: Props) => {
  const {
    studentId,
    from,
    to,
    schedule,
    onClose,
    onMutateSuccess,
    onMutateError,
  } = props;

  const mutateState = useMutateSchedule({
    studentId,
    from,
    to,
    refetchOnSettled: true,
  });

  const rollback = useRollback({ studentId, from, to });

  const handleClose = React.useCallback(() => {
    rollback();
    onClose();
  }, [rollback, onClose]);

  const onSubmit = React.useCallback(() => {
    mutateState.mutate(
      { schedule, updateType: "this" },
      {
        onSuccess: () => {
          onClose();
          onMutateSuccess("更新を完了しました");
        },
        onError: () => {
          onMutateError("更新に失敗しました");
        },
      },
    );
  }, [schedule, mutateState, onClose, onMutateSuccess, onMutateError]);

  return (
    <>
      <Modal.Header onClose={handleClose}>予定の移動</Modal.Header>
      <Modal.Body>
        <p>この予定を移動しますか？</p>
        <div className={styles.buttons}>
          <div>
            <Button variant="outline" onClick={handleClose}>
              キャンセル
            </Button>
          </div>
          <div>
            <Button
              disabled={mutateState.isLoading}
              isLoading={mutateState.isLoading}
              onClick={onSubmit}
            >
              移動
            </Button>
          </div>
        </div>
      </Modal.Body>
    </>
  );
};
